/* section.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4Gb5FivLZJ%3Aafter%7Bdisplay%3Ablock%7D%0A._0OU75rvLZJ%3Abefore%7Bdisplay%3Ablock%7D%0A._47eTBtZimw%3Aafter%7Bheight%3A6px%7D%0A._1lBcDcZimw%3Abefore%7Bheight%3A6px%7D%0A._0GBAIrogpp%3Aafter%7Bcontent%3A%22%22%7D%0A._3Ku51Iogpp%3Abefore%7Bcontent%3A%22%22%7D%0A._420PbdZimw%20%5Bdata-ds--menu--heading-item%5D%7Bmargin-block-end%3A6px%7D%0A._3LXXKoSPN1%20%5Bdata-ds--menu--heading-item%5D%7Bmargin-block-start%3A20px%7D%0A._1DqDD4EbN9%20%5Bdata-ds--menu--heading-item%5D%3Afirst-of-type%7Bmargin-block-start%3A14px%7D%0A._0Ipfpy2AF2%20%5Bdata-ds--menu--skeleton-heading-item%5D%7Bmargin-block-end%3A9px%7D%0A._1apEF8fFOW%20%5Bdata-ds--menu--skeleton-heading-item%5D%7Bmargin-block-start%3A25px%7D%0A._3R93WOXCiO%20%5Bdata-ds--menu--skeleton-heading-item%5D%3Afirst-of-type%7Bmargin-block-start%3A19px%7D%0A._38a67RA17z%3Afocus%7Boutline-offset%3A-1px%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._1v3aPqo71H%7Bborder-block-start%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-menu-seperator-color%2Cvar(--ds-border%2C%230b120e24))%7D%0A%5Bdata-section%5D%2B._1wX8q6mW1D%7Bmargin-block-start%3A-6px%7D%0A._2Y7lL42ADO%7Bpadding-inline%3Avar(--ds-space-100%2C8px)%7D");



















import { Children, forwardRef, Fragment, type Ref } from 'react';
import HeadingItem from '../menu-item/heading-item';
import type { SectionProps } from '../types';
const itemHeadingTopMargin = 20;
const itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const skeletonHeadingHeight = 8;
const skeletonHeadingMarginOffset = 3;
const skeletonHeadingTopMargin = itemHeadingTopMargin + (itemHeadingContentHeight - skeletonHeadingHeight) - skeletonHeadingMarginOffset;
const sectionPaddingTopBottom = 6;
const styles = {
  root: "_4Gb5FivLZJ _0OU75rvLZJ _47eTBtZimw _1lBcDcZimw _0GBAIrogpp _3Ku51Iogpp _420PbdZimw _3LXXKoSPN1 _1DqDD4EbN9 _0Ipfpy2AF2 _1apEF8fFOW _3R93WOXCiO _38a67RA17z",
  scrollable: "_4bt5LAIZbP _2WAcuGIZbP _3YEZNO7dHp",
  unscrollable: "_3YEZNOdnbC",
  thinSeparator: "_1v3aPqo71H",
  noSeparator: "_1wX8q6mW1D",
  sideNavSectionHeading: "_2Y7lL42ADO"
};

/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */
const Section: React.ForwardRefExoticComponent<React.PropsWithoutRef<SectionProps> & React.RefAttributes<HTMLElement>> = forwardRef<HTMLElement, SectionProps>(({
  children,
  title,
  titleId,
  testId,
  isScrollable,
  hasSeparator,
  id,
  isList = false,
  isSideNavSection = false,
  label,
  // Although this isn't defined on props it is available because we've used
  // Spread props below and on the jsx element. To forcibly block usage I've
  // picked it out and supressed the expected type error.
  // @ts-expect-error
  className: UNSAFE_className,
  ...rest
}, ref) => {
  const content = isList ? <ul style={{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    margin: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    padding: 0
  }}>
				{Children.map(Children.toArray(children), (child, index) => <li
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style={{
      listStyleType: 'none',
      margin: 0,
      padding: 0
    }} key={index}>
						{child}
					</li>)}
			</ul> : children;
  const childrenMarkup = title !== undefined ? <Fragment>
					<HeadingItem testId={testId && `${testId}--heading`} aria-hidden
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    className={ax([isSideNavSection && styles.sideNavSectionHeading])}>
						{title}
					</HeadingItem>
					{content}
				</Fragment> : <Fragment>{content}</Fragment>;
  return <div {...rest}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax([styles.root, isScrollable ? styles.scrollable : styles.unscrollable, hasSeparator ? styles.thinSeparator : styles.noSeparator, UNSAFE_className])} id={id}
  // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
  // We have made a deliberate choice to leave this behaviour as is.
  aria-label={title || label} aria-labelledby={titleId} data-testid={testId} role="group" data-section ref={(ref as Ref<HTMLDivElement>)}>
				{childrenMarkup}
			</div>;
});
export default Section;